import React, { useState, useEffect, useRef } from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { ProfileFirstActions } from "ts-interfaces";
import { formatPrice } from "ui";
import { PaymentComponent } from "./PaymentComponent.tsx";

import { setProfileFirstAction } from "../libs/util.ts";
import { getGoogleAnalyticsProductInfo } from "./config.js";
import { ProfilePrices } from "./useStripeStore.tsx";
import { PromoCodeComponent } from "./PromoCodeComponent.tsx";

interface FinalizePaymentProps {
    onSuccess: any;
    onBack: any;
    selectedPlan: ProfilePrices;
}
export const FinalizePayment = ({ onSuccess, onBack, selectedPlan }:FinalizePaymentProps) => {
    const [promoCode, setPromoCode] = useState('');
    const [promoId, setPromoId] = useState('');
    const [finalPrice, setFinalPrice] = useState(selectedPlan.local_price);
    // What the card form shows it will charge (minor units); the invoice has the last word.
    const chargeAmount = Math.round(Number(finalPrice) || 0);
    const chargeCurrency = String(selectedPlan.currency || 'usd').toLowerCase();

    const hasTrackedView = useRef(false);
    useEffect(() => {
      if (hasTrackedView.current) return;
      hasTrackedView.current = true;
      setProfileFirstAction(ProfileFirstActions.FINALIZE_PAYMENT_MODAL).finally(()=>{});
      if (window.gtag && selectedPlan) window.gtag("event", "begin_checkout", getGoogleAnalyticsProductInfo(selectedPlan));
    }, [selectedPlan]);

    const onApplyPromoCode = (promo_id: string, discount_percentage: number) => {
      if(selectedPlan.local_price) {
        const discountAmount = (selectedPlan.local_price * discount_percentage) / 100;
        setFinalPrice(selectedPlan.local_price - discountAmount);
        setPromoId(promo_id);
      }
    }

    const onResetPromoCode = () => {
      setFinalPrice(selectedPlan.local_price);
      setPromoId('');
    }

    return (
      <Box sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: "30px 25px 16px",
        width: '100%',
        maxWidth: '450px',
        marginLeft: 'auto',
        marginRight: 'auto',
        boxSizing: 'border-box',
      }}>
        <IconButton
          onClick={onBack}
          disableRipple
          sx={{
            alignSelf: 'flex-start',
            marginLeft: '-12px',
            padding: '4px 8px 4px 4px',
            color: '#8C8C8C',
            borderRadius: '6px',
            '&:hover': { backgroundColor: 'transparent', color: '#5C5C5C' },
          }}
        >
          <ChevronLeftIcon sx={{ fontSize: '24px' }} />
          <Typography sx={{ fontSize: '16px', fontWeight: 500, color: 'inherit' }}>Back</Typography>
        </IconButton>

        <Box sx={{
          flex: 1,
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingRight: '10px',
          display: 'flex',
          flexDirection: 'column',
        }}>
          <Typography sx={{ fontSize: '24px', fontWeight: 700, marginBottom: '12px' }}>
            Finalize Payment
          </Typography>

          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ marginBottom: '8px' }}>
            <Typography sx={{ fontSize: '13px', color: '#8C8C8C' }}>Total Amount:</Typography>
            <Typography sx={{ fontSize: '16px', fontWeight: 700 }} data-price={finalPrice}>
              {formatPrice(finalPrice, selectedPlan.currency, true)}
            </Typography>
          </Stack>

          <PromoCodeComponent
            promoCode={promoCode}
            setPromoCode={setPromoCode}
            onApplyPromoCode={onApplyPromoCode}
            onResetPromoCode={onResetPromoCode}
            selectedPlan={selectedPlan}
          />

          <PaymentComponent amount={chargeAmount} currency={chargeCurrency} onSuccess={onSuccess} selectedPlan={selectedPlan} promoId={promoId} />
        </Box>
      </Box>
    );
  };
